<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.details" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.changePassword" icon="vxe-icon-edit" mode="text" status="danger" @click="changePassword"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="operator" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="24">
            <a-form-model-item label="用户名">
              <vxe-input v-model="operator.no" disabled prefix-icon="vxe-icon-user" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="24">
            <a-form-model-item label="姓名">
              <vxe-input v-model="operator.name" disabled prefix-icon="vxe-icon-user" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <PasswordModify ref="passwordModify" :operator="operator"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { OPERATOR } from '@/store/mutation-types'
import PasswordModify from '@/views/user/PasswordModify'

export default {
  name: 'PersonalSetting',
  components: { PasswordModify },
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    }
  },
  methods: {
    changePassword() {
      this.$refs.passwordModify.visible = true
    }
  }
}
</script>